/* src/app/components/article-option-group-multiple/article-option-group-multiple.component.scss */
ion-item {
  width: 100%;
  margin-bottom: 6px;
}
.checkbox-price {
  color: #b5b5b5;
}
.hidden {
  visibility: hidden;
}
.price {
  margin-right: 10px;
}
.qty__btn {
  width: 24px;
  height: 24px;
  margin: 0 !important;
  box-shadow: none;
  --box-shadow: none;
}
.qty__btn button {
  box-shadow: unset !important;
}
.qty__btn span {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 19px;
  color: white;
}
.qty .qty-number {
  margin: 0 4px;
  text-align: center;
  min-width: 15px;
  color: var(--ion-color-primary);
}
ion-checkbox {
  margin: 0 12px 0 0;
}
app-tag {
  display: inline-block;
}
ion-item {
  background: #FFFFFF;
  border: 0.5px solid #E2DCD5;
  border-radius: 10px;
  margin: 10px 0px;
}
ion-label {
  font-size: 14px;
}
@media (min-width: 991px) {
  ion-label {
    padding-right: 5px;
  }
}
.item-img {
  width: 50px;
  padding: 7px;
}
.mehr-articles {
  width: fit-content;
}
.mehr-articles div {
  background: white;
  border: 1px solid black;
  padding: 5px 10px;
  border-radius: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mehr-articles div h3 {
  margin-right: 20px;
}
.mehr-articles div ion-icon {
  color: black;
  margin-left: 15px;
  rotate: 0deg;
  transition: rotate 0.7s;
}
.mehr-articles div ion-icon.rotate {
  rotate: 180deg;
}
/*# sourceMappingURL=article-option-group-multiple.component.css.map */
